
// Google reCAPTCHA site key
export const RECAPTCHA_SITE_KEY = '6LfdZRYrAAAAAD2h0ezazipQ3P-b4ajGHGgVNwI7'; 

/**
 * Check if reCAPTCHA is loaded and ready
 */
export function isCaptchaReady(): boolean {
  return typeof window !== 'undefined' && 
         typeof (window as any).grecaptcha !== 'undefined' && 
         typeof (window as any).grecaptcha.ready !== 'undefined';
}

/**
 * Validate a reCAPTCHA token on the client-side
 * Note: For full security, token should also be validated server-side
 */
export async function validateCaptchaToken(token: string | null): Promise<boolean> {
  if (!token) {
    return false;
  }
  
  // In a production environment, you would validate this token with Google's API
  // using the secret key on the server side
  return token.length > 0;
}
